import { defineStore } from 'pinia';

export const useDesktopAgentStore = defineStore('desktopAgentStore', {
	state: () => ({
		websocket_connection: undefined,
		websocket_connection_status: 'DISCONNECTED',

		reconnect_attempts: 0,
		is_reconnecting: false,
		reconnection_timeout: undefined,
		next_reconnect_attempt: undefined,
		agent_version: undefined,
	}),
	actions: {
		// setOutOfDate(status) {
		// 	this.is_out_of_date = !!status;
		// },
	},
});
